import { css } from '../../styled-system/css';

export interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  fullScreen?: boolean;
  class?: string;
}

export function LoadingSpinner(p: LoadingSpinnerProps) {
  const sz = p.size ?? 'md';
  const spinnerPx = sz === 'sm' ? '20px' : sz === 'md' ? '40px' : '60px';
  const borderPx = sz === 'sm' ? '2px' : sz === 'md' ? '3px' : '4px';

  const spinnerStyles = css({
    border: `${borderPx} solid`,
    borderColor: 'gray.600',
    borderTopColor: 'primary',
    borderRadius: 'full',
    width: spinnerPx,
    height: spinnerPx,
    animation: 'spin',
  });

  const containerStyles = css({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 'xl',
    ...(p.fullScreen ? {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      bg: 'rgba(12, 16, 21, 0.92)',
      backdropFilter: 'blur(4px)',
      zIndex: 9999,
    } : {}),
  });

  return (
    <div class={containerStyles}>
      <div class={spinnerStyles} />
    </div>
  );
}
